import script from "./UserTableRow.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserTableRow.vue?vue&type=script&lang=ts&setup=true"

import "./UserTableRow.vue?vue&type=style&index=0&id=2c4b007e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\WebstormProjects\\wisevet-live\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c4b007e"]])

export default __exports__